import { render, staticRenderFns } from "./BecomeKeyPartner.vue?vue&type=template&id=ce36a9a2&"
import script from "./BecomeKeyPartner.vue?vue&type=script&lang=js&"
export * from "./BecomeKeyPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports